export default __webpack_public_path__ + "static/media/servicebg.0df0d823.png";